<template>
  <data-section
    theme="blue"
    title="其他產險-車險"
    :isLoading="isLoading"
    :datas="highlightModify"
    :_fields="
      [
        {
          name: '保單號碼',
          key: 'ceplcno',
          width: 110,
          sortable: true,
          orderByMultiKey: ['ceplcno'],
          orderByMultiType: ['asc'],
        },
        {
          name: '產險公司',
          key: 'comp_nm',
          width: 101,
          sortable: true,
          orderByMultiKey: ['comp_nm'],
          orderByMultiType: ['asc'],
        },
        {
          name: '險種',
          key: 'contract_type',
          width: 90,
          sortable: true,
          orderByMultiKey: ['contract_type'],
          orderByMultiType: ['asc'],
        },
        {
          name: '被保人',
          key: 'ceisdnm',
          width: 87,
          sortable: true,
          className: 'link text-underline',
          orderByMultiKey: ['ceisdnm'],
          orderByMultiType: ['asc'],
        },
        {
          name: '有效期間',
          key: 'celpsdt',
          width: 82,
          sortable: true,
          orderByMultiKey: ['celpsdt'],
          orderByMultiType: ['asc'],
        },
        {
          name: '保費',
          key: 'premium',
          width: 75,
          thClassName: 'text-right',
          className: 'text-right',
          sortable: true,
          orderByMultiKey: ['premium'],
          orderByMultiType: ['asc'],
        },
        {
          name: '車牌號碼',
          key: 'lic_no',
          width: 78,
          sortable: true,
          orderByMultiKey: ['lic_no'],
          orderByMultiType: ['asc'],
        },
        {
          name: '引擎號碼',
          key: 'eg_no',
          width: 117,
          sortable: true,
          orderByMultiKey: ['eg_no'],
          orderByMultiType: ['asc'],
        },
        {
          name: '車種',
          key: 'veh_name',
          width: 116,
          sortable: true,
          orderByMultiKey: ['veh_name'],
          orderByMultiType: ['asc'],
        },
        {
          name: '出廠年份',
          key: 'target_birth',
          width: 83,
          sortable: true,
          className: 'text-left',
          orderByMultiKey: ['target_birth'],
          orderByMultiType: ['asc'],
        },
      ].concat(_fields)
    "
    @toggle="
      (isShow) => $router.assignQuery({ OtherPropertyCarInsuranceShow: isShow })
    "
    :initShow="$route.query['OtherPropertyCarInsuranceShow'] !== 'false'"
  >
    <template scope="props" v-if="refresh">
      <data-table
        v-bind="props"
        @changeSort="
          (sort) =>
            $router.assignQuery({
              [`OtherPropertyCarInsuranceSort`]: JSON.stringify(sort),
            })
        "
        :initSort="
          $route.query[`OtherPropertyCarInsuranceSort`]
            ? JSON.parse($route.query[`OtherPropertyCarInsuranceSort`])
            : null
        "
      >
        <template slot="contract_type" scope="item">{{
          translate.carContractType[item.data.contract_type]
        }}</template>
        <template slot="celpsdt" scope="item">
          <div
            class="pre-formatted"
            v-html="
              buildStartEndString(
                getROCDate(item.data.ceplcdt),
                getROCDate(item.data.celpsdt)
              )
            "
          ></div>
        </template>
        <template slot="ceisdnm" scope="item">
          <span
            @click="routeToCustDetail(item.data.ceisdno, item.data.ceisdnm)"
          >
            {{ item.data.ceisdnm | truncate }}
          </span>
        </template>
        <template slot="premium" scope="item"
          >{{ item.data.premium | numberFormat }}元</template
        >
        <template slot="target_birth" scope="item">
          {{ item.data.target_birth ? item.data.target_birth + "年" : "" }}
        </template>
        <template slot="action" scope="item">
          <div class="dropdown">
            <a
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              class="btn btn-icon btn-default btn-sm"
              role="button"
            >
              <i class="icon-more"></i>
            </a>
            <div class="dropdown-menu">
              <a
                role="button"
                class="dropdown-item text-green text-underline"
                @click="toUpdate(item.data.pt_contractx_id)"
                >修改</a
              >
              <a
                role="button"
                class="dropdown-item text-green text-underline"
                @click="doDelete(item.data)"
                >刪除</a
              >
            </div>
          </div>
        </template>
      </data-table>
    </template>
  </data-section>
</template>

<script>
import InsuranceMixins from "./Insurance";
import HighlightModify from "./HighlightModify";
import { contract_type_enum } from "@/desktop/contract/CarInsuranceContractTypes";
import { deleteOtherPropertyInsurance } from "@/service";

export default {
  mixins: [InsuranceMixins, HighlightModify],
  methods: {
    toUpdate(pt_contractx_id) {
      this.$router.push({
        name: "car-insurance",
        query: {
          pt_contractx_id,
        },
      });
    },
    async doDelete(data) {
      await this.$deleteConfirm(
        this.buildDeleteMessage(
          `${data.ceplcno} ${contract_type_enum[data.contract_type]}`
        )
      );
      await this.deleteSuccessHandler(
        deleteOtherPropertyInsurance({
          pt_contractx_id: data.pt_contractx_id,
        })
      );
      this.isLoading = true;
      this.$bus.emit(
        "other-property-insurance.get",
        () => (this.isLoading = false)
      );
    },
  },
};
</script>
